/**
 * Laravel Frontend scripts
 */

import 'promise-polyfill/src/polyfill';

import Application from './core';

import $ from 'jquery';
import 'jquery.mmenu';
import bootstrap from 'bootstrap';
import AOS from 'aos';
import 'bootstrap-datepicker';
import 'datatables';
import 'cookieconsent';
import 'nouislider';

import './utils/maps.js';

/** and expose it to browser window object */
window.$ = $;
window.App = new Application();


/*====================================
X-CSRF-TOKEN AXIOS
======================================*/
$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});


/*====================================
Upload size limit
======================================*/

$("#imageupload").on('change', function () {                           
  if (this.files[0].size > 5242880) {
    alert("Die Datei ist zu groß! Maximale Größe ca. 5MB.");
    this.value = "";
  };
});

/*====================================
Keyboard navigation
======================================*/

function leftArrowPressed() {
  let href = $('.details-navigation-left a').attr('href')
  window.location = href;
}

function rightArrowPressed() {
  let href = $('.details-navigation-right a').attr('href')
  window.location = href;

}

if (document.getElementById('details')) {
  document.onkeydown = function (evt) {
    evt = evt || window.event;
    switch (evt.keyCode) {
      case 37:
        leftArrowPressed();
        break;
      case 39:
        rightArrowPressed();
        break;
    }
  };
}



/*====================================
Cookie Banner
======================================*/

window.addEventListener("load", function () {
  window.cookieconsent.initialise({
    "palette": {
      "popup": {
        "background": "rgba(199, 145, 19, 0.8);"
      },
      "button": {
        "background": "#edede4"
      }
    },
    "content": {
      "message": "Diese Webseite verwendet Cookies, um die Bedienfreundlichkeit zu erhöhen.",
      "dismiss": "OK",
      "link": "Mehr erfahren",
      "href": "/datenschutzerklarung"
    }
  })
});


/*====================================
Change Header color on scroll
======================================*/

var win = $(window);
var sticky_visible = false;

win.on('scroll', function () {
  if (win.scrollTop() > 5 && sticky_visible == false) {
    $('#main_navbar.navigation-background').removeClass('transparent-color');
    sticky_visible = true;
  } else if (win.scrollTop() == 0 && sticky_visible == true) {
    $('#main_navbar.navigation-background').addClass('transparent-color');
    sticky_visible = false;
  }
});


/*====================================
To Top Button
======================================*/

if ($('#back-to-top').length) {
  var scrollTrigger = 300,
    backToTop = function () {
      var scrollTop = $(window).scrollTop();
      if (scrollTop > scrollTrigger) {
        $('#back-to-top').addClass('show');
      } else {
        $('#back-to-top').removeClass('show');
      }
    };
  backToTop();
  $(window).on('scroll', function () {
    backToTop();
  });
  $('#back-to-top').on('click', function (e) {
    e.preventDefault();
    $('html,body').animate({
      scrollTop: 0
    }, 700);
  });
}


/*====================================
Extend description in header
======================================*/

$('.dropdown_arrow').on('click', function (e) {
  e.preventDefault();

  $(this).hide();;

  $(this).siblings('.dropdown_text').slideToggle(400, function () {
    var header_section = $(this).closest('#header');
    if (header_section.hasClass('open')) {
      header_section.removeClass('open');
    } else {
      header_section.addClass('open');
    }
  });

  $(this).closest('.dropdown_text').slideToggle(400, function () {
    var header_section = $(this).closest('#header');
    if (header_section.hasClass('open')) {
      header_section.removeClass('open');
    } else {
      header_section.addClass('open');
    }
    $('.dropdown_arrow').show();
  });

});




/*====================================
Extend register form
======================================*/

$('#register_form h2').on('click', function (e) {
  e.preventDefault();

  var clicked_button = $(this);
  var clicked_button = $(this).find('.oben');
  var register_form = $(this).closest('#register_form').find('form');

  register_form.slideToggle();

  if (clicked_button.hasClass('open')) {
    clicked_button.removeClass('open');
  } else {
    clicked_button.addClass('open');
  }
});

$('.register-link').on('click', function (e) {
  e.preventDefault();

  var register_form = $('#register_form').find('form');
  $('html,body').animate({
    scrollTop: $('#register_form').offset().top - 51
  }, 'slow');

  register_form.slideToggle();
});

$('.login-link').on('click', function (e) {
  e.preventDefault();

  var login_form = $('#login_form');
  $('html,body').animate({
    scrollTop: $('#login_form').offset().top
  }, 'slow');

  login_form.slideToggle();
});



/*====================================
Extend login form
======================================*/

$('.login_link').on('click', function (e) {
  e.preventDefault();
  var login_form = $('#login_form');
  login_form.slideToggle();
});

$('.login_arrow').on('click', function (e) {
  e.preventDefault();
  var login_form = $('#login_form');
  login_form.slideToggle();
});


/*====================================
AOS load
======================================*/

AOS.init({
  "once": true
});

/*====================================
READFILE - Image uplaod
======================================*/

function readURL(input) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();

    reader.onload = function (e) {
      $('#preview-image').attr('src', e.target.result);
    };

    reader.readAsDataURL(input.files[0]);

    $('#preview-image').css('display', 'initial');
  }
}

$("#upload-form input[type=file]").change(function () {
  readURL(this);
});


/*====================================
Upload Button click trigger
======================================*/

$("#buttons.on_click_upload").on('click', function (event) {
  $("input[id='imageupload']").click();
});



/*====================================
Search toggle
======================================*/

$("#buttons #bilder_search .search-field").on('focus', function (event) {
  event.preventDefault();
  $('#bilder_search .text').toggleClass('show-search');
});

$('#bilder_search .search-field').on('blur', function () {
  if($('#bilder_search .search-field').val() == ''){
    $('#bilder_search .text').removeClass('show-search');
  }
});

// Submit on icon click
$('#bilder_search .icon').on('click', () => {
  $('#bilder_search form').submit();
});

if($('#bilder_search .search-field').val() != ''){
  $('#bilder_search .text').addClass('show-search');
}


/*====================================
Reply comment toggle
======================================*/

$(".reply-btn").on('click', function (event) {
  event.preventDefault();
  $(this).siblings('.reply-box').toggle();
});


/*====================================
File upload validation
======================================*/

$('#upload-form').on('submit', () => {

  $('#upload-form input[type=submit]').attr("disabled", true);


  var $imageInput = $("#imageupload"),
    $titleInput = $('#title'),
    $categories = $('input[name="category[]"].kategorie:checked'),
    $ortsteil = $('input[name="category[]"].ortsteil:checked'),
    $timeCheckbox = $('input[name="period_type"]:checked'),
    $timeInput = $('input[name="taken_at"]');

  //- Check if image is selected
  if ($imageInput.val().length == 0) {
    return formError('Bitte Bild hochladen!')
  }

  //- Check if title is inserted
  if ($titleInput.val().length == 0) {
    return formError('Bitte geben Sie den Bildtitel ein')
  }

  //- Check if at least one category is selected
  if ($ortsteil.length < 1) {
    return formError('Bitte wählen Sie mindestens eine Ortsteil Kategorie aus!')
  }

  //- Check if at least one category is selected
  if ($categories.length < 1) {
    return formError('Bitte wählen Sie mindestens eine Kategorie aus!')
  }

  //- Check if period type is selected
  if (!$timeCheckbox.val()) {
    return formError('Bitte wählen Sie ein Datum der Aufnahme!')
  } else {
    //- Check if period is inserted if it's known
    if ($timeCheckbox.val() != 'Unbekannt' && !$timeInput.val().length) {
      return formError('Bitte geben Sie ein Jahr ein!')
    }
  }

  return true
});

function formError(msg) {
  var $errorContainer = $('#error_message');

  $errorContainer.text(msg).show();

  $('html,body').animate({
    scrollTop: $errorContainer.offset().top - 165
  }, 'slow');

  $('#upload-form input[type=submit]').attr("disabled", false);

  return false
}

/*====================================
Scroll top on mobile login click
======================================*/

$('.login_link').on('click', function (e) {

  $('.navbar-toggler').click();

  $("html, body").animate({
    scrollTop: $('body').offset().top
  }, 500);

})

/*====================================
Delete images confiramtion
======================================*/

$(".imagerow .delete_image").click(function () {
  if (!confirm("Sie möchten wirklich löschen?")) {
    return false;
  }
});

/*====================================
Prevent wheel scroll on number input fields
======================================*/
$('form').on('focus', 'input[type=number]', function (e) {
  $(this).on('mousewheel.disableScroll', function (e) {
      e.preventDefault()
  })
})

$('form').on('blur', 'input[type=number]', function (e) {
  $(this).off('mousewheel.disableScroll')
})

/*====================================
Move cursor to the end of the search field
======================================*/
moveCursorToEnd($('.search-field'));

function moveCursorToEnd(input) {
  var originalValue = input.val();
  if (originalValue.length) {
    input.val('');
    input.blur().focus().val(originalValue);
  }
}
